export default {
      id: "swapHoriz-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#swapHoriz-usage",
      toString: function () {
        return this.url;
      }
    }